import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { formValueSelector } from 'redux-form';
import {
    FETCH_MARQUES_VEHICULIER,
    fetchMarquesVehicule,
} from '../../../../../../redux/actions/app/vehiculier/vehiculier.actions';
import { getLoadingEntity, getMarquesVehiculeUi } from '../../../../../../redux/selectors/ui/ui.selectors';
import MarqueVehicule from './MarqueVehicule';

const mapStateToProps = (state) => {
    const selector = formValueSelector('devis-direct');

    return {
        type: selector(state, `typeVehicule`),
        marque_id: selector(state, `marqueVehicule`),
        marque: selector(state, `marqueVehicule`),
        marques: getMarquesVehiculeUi(state),
        loading: getLoadingEntity(state, FETCH_MARQUES_VEHICULIER),
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchMarquesVehicule: ({ type }) => fetchMarquesVehicule({ type }),
        },
        dispatch,
    );

const MarqueVehiculeContainer = compose(connect(mapStateToProps, mapDispatchToProps))(MarqueVehicule);

export default MarqueVehiculeContainer;
